var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { get, Space, TextBody, useMediaSize } from '@ally/metronome-ui';
import { formattedDate, isAfterDeliverOnDate } from '../utils';
import TimelineTrackerMarker from './TimelineTrackerMarker';
function getStatusContent(_a) {
    var activityName = _a.activityName, showAchDelivered = _a.showAchDelivered, statusHistory = _a.statusHistory, step = _a.step;
    var useDelivered = (statusHistory === null || statusHistory === void 0 ? void 0 : statusHistory.status) === 'Completed' ||
        activityName === 'InternalTransfers' ||
        showAchDelivered;
    switch (step) {
        case 'Confirmed':
            return 'Ordered';
        case 'InProcess':
            return activityName === 'ACHTransfer' ? 'Processing' : 'Ordered';
        case 'Completed':
        case 'Posted':
            return useDelivered ? 'Delivered' : 'Deliver On';
        default:
            return step;
    }
}
var TrackerStep = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1 1 0%;\n  margin: 0;\n  padding: 0;\n  counter-increment: counter;\n  min-width: 22px;\n\n  &:last-child {\n    > div::after {\n      display: none;\n    }\n  }\n\n  ", " {\n    display: flex;\n    align-items: flex-start;\n    position: relative;\n    padding-bottom: ", ";\n\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      background-color: ", ";\n      top: 11px;\n      left: 11px;\n      width: 1px;\n      height: 100%;\n    }\n\n    &:last-child {\n      padding-bottom: 0;\n\n      :before {\n        display: none;\n      }\n    }\n  }\n"], ["\n  flex: 1 1 0%;\n  margin: 0;\n  padding: 0;\n  counter-increment: counter;\n  min-width: 22px;\n\n  &:last-child {\n    > div::after {\n      display: none;\n    }\n  }\n\n  ", " {\n    display: flex;\n    align-items: flex-start;\n    position: relative;\n    padding-bottom: ", ";\n\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      background-color: ", ";\n      top: 11px;\n      left: 11px;\n      width: 1px;\n      height: 100%;\n    }\n\n    &:last-child {\n      padding-bottom: 0;\n\n      :before {\n        display: none;\n      }\n    }\n  }\n"])), get.media.down('md'), get.space('md'), get.colors('slate-3'));
var TimelineTrackerStep = function (_a) {
    var event = _a.event, status = _a.status, statusHistory = _a.statusHistory, step = _a.step;
    var deliverOnDate = event.eventModelData.deliverOnDate;
    var isMdUp = useMediaSize('MdUp');
    var showDeliverOnDate = event.activityName === 'ACHTransfer' && step === 'Completed';
    var showAchDelivered = isAfterDeliverOnDate(deliverOnDate);
    return (React.createElement(TrackerStep, null,
        React.createElement(TimelineTrackerMarker, { status: showAchDelivered ? 'Success' : status }),
        React.createElement(TextBody, { tag: "div", size: "sm" },
            React.createElement(Space, { pt: isMdUp ? 'xxs' : 'none' },
                React.createElement(TextBody, { tag: "p", size: "xs", weight: "bold" }, getStatusContent({
                    activityName: event.activityName,
                    showAchDelivered: showAchDelivered,
                    statusHistory: statusHistory,
                    step: step,
                }))),
            statusHistory && !showDeliverOnDate && (React.createElement(TextBody, { tag: "p", size: "sm" }, formattedDate(statusHistory.eventDateTime, 'MMM D'))),
            showDeliverOnDate && (React.createElement(TextBody, { tag: "p", size: "sm" }, formattedDate(deliverOnDate, 'MMM D'))))));
};
export default TimelineTrackerStep;
var templateObject_1;
//# sourceMappingURL=TimelineTrackerStep.js.map